import axiosInstance from "@/config/axiosInstance";
import { ActionApi } from "@/config/cms/api";
import { getCMSApiRoute } from "@/helpers/api.util";
import BookmarkEmptyIcon from "@/helpers/svg/bookmarkEmpty.svg";
import SerialNameIcon from "@/helpers/svg/serialNameIcon.svg";
import { Fade } from "@mui/material";
import { Button } from "@nextui-org/react";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const SerialContentActions = ({ contentKey }) => {
  const { profile } = useSelector((state) => state.Auth);
  const [actionsLoading, setActionsLoading] = useState({
    bookmark: false,
    like: false,
    dislike: false,
    master: false,
  });
  const [actionData, setActionData] = useState({});

  const getContentActions = async () => {
    setActionsLoading(Object.assign({}, actionsLoading, { master: true }));
    try {
      const response = await axiosInstance.get(
        getCMSApiRoute("action/content"),
        {
          params: {
            contentKey,
          },
        }
      );

      if (response.status === 200) {
        const { data } = response.data;
        setActionData(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setActionsLoading(Object.assign({}, actionsLoading, { master: false }));
    }
  };

  useEffect(() => {
    getContentActions();

    // Refetch when returning from player
    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        getContentActions();
      }
    };
    const handlePageShow = (e) => {
      if (e.persisted) getContentActions();
    };
    document.addEventListener("visibilitychange", handleVisibility);
    window.addEventListener("pageshow", handlePageShow);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  const handleSaveBookmark = async () => {
    setActionsLoading(Object.assign({}, actionsLoading, { bookmark: true }));

    try {
      let response;
      if (!actionData?.userActions?.bookmark) {
        response = await ActionApi.prototype.actionControllerInsertBookmark(
          {
            contentKey,
          },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("userAccessToken")}`,
            },
          }
        );
        setActionData({
          ...actionData,
          userActions: {
            ...actionData.userActions,
            bookmark: true,
          },
        });
      } else {
        response = await ActionApi.prototype.actionControllerRemoveBookmark(
          {
            contentKey,
          },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("userAccessToken")}`,
            },
          }
        );

        setActionData({
          ...actionData,
          userActions: {
            ...actionData.userActions,
            bookmark: false,
          },
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setActionsLoading(Object.assign({}, actionsLoading, { bookmark: false }));
    }
  };

  if (!profile.isLogin) return null;

  return (
    <Fade in={profile.isLogin && !actionsLoading.master} timeout={300}>
      <div className="content-detail-content-actions flex gap-3 z-10">
        <Button
          variant="light"
          isLoading={actionsLoading.bookmark}
          isIconOnly
          onClick={handleSaveBookmark}
          aria-label={
            actionData?.userActions?.bookmark
              ? "حذف از نشان‌شده‌ها"
              : "افزودن به نشان‌شده‌ها"
          }
        >
          {actionData?.userActions?.bookmark ? (
            <SerialNameIcon />
          ) : (
            <BookmarkEmptyIcon />
          )}
        </Button>
      </div>
    </Fade>
  );
};

export default SerialContentActions;
